import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { FunctionRequirement } from '../../../types/drbfm';

interface FunctionRequirementTableProps {
  requirements: FunctionRequirement[];
}

const FunctionRequirementTable: React.FC<FunctionRequirementTableProps> = ({
  requirements,
}) => {
  const { t } = useTranslation();

  return (
  <div className="max-h-80 overflow-auto">
    <Table aria-label={t('drbfm.workflow.matrix.requirementListAriaLabel', '機能要求一覧')}>
      <TableHeader className="sticky top-0 z-10 bg-card">
        <TableRow>
          <TableHead>No.</TableHead>
          <TableHead>{t('drbfm.workflow.matrix.functionHierarchyHeader', '機能階層')}</TableHead>
          <TableHead>{t('drbfm.workflow.matrix.requirementHeader', '要求')}</TableHead>
          <TableHead>{t('drbfm.workflow.matrix.inspectionAxisHintHeader', '点検軸ヒント')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {requirements.map((requirement) => (
          <TableRow key={requirement.id}>
            <TableCell>{requirement.requirementNo}</TableCell>
            <TableCell>
              {[requirement.functionL1, requirement.functionL2, requirement.functionL3]
                .filter(Boolean)
                .join(' / ')}
            </TableCell>
            <TableCell>{requirement.requirementText}</TableCell>
            <TableCell>{requirement.inspectionAxisHints.join(', ') || '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
  );
};

export default FunctionRequirementTable;
